import { useState, useEffect, useContext } from 'react'
import { getAllLicenses } from '../../services/licenceMasterService';
import { getAllPackages } from '../../services/packageMasterServices';
import * as SubscriptionServices from '../../services/subscriptionServices'
import DateTime from 'react-datetime';
import "react-datetime/css/react-datetime.css";
import moment from 'moment';
import { hanldeSortingArray } from '../../utils/sortingByColumn';
import NoDataError from '../../components/NoDataError';
import { Button, Modal, ModalDialog } from 'react-bootstrap';
import Draggable from 'react-draggable';
import { ThemeContext } from '../../layout/BaseLayout';

const subscriptionModalDragModal = (props) => {
	return (
		<Draggable handle=".modal-header">
			<ModalDialog {...props} />
		</Draggable>
	);
};

const Subscriptions = () => {

	const defaultSubscriptionObj = {
		"licenseId": 0,
		"packageId": 0,
		"userName": null,
		"subscriptionStatus": "All",
		"startDate": null,
		"endDate": null
	}

	const defaultUpdateSubscripionObj = {
		"subscriptionId": "",
		"licenseId": "",
		"packageId": 0,
		"userName": "",
		"subscriptionStatus": "",
		"startDate": null,
		"endDate": null,
		"adminComment": ""
	}

	const defaultSortingOrderObj = {
		sortingOrder: 'asc',
		upDownArrowColumn: null,
		fieldType: null
	}

	const [licencesList, setLicencesList] = useState([]);
	const [packagesList, setPackagesList] = useState([]);
	const [subscriptionObj, setSubscriptionObj] = useState({ ...defaultSubscriptionObj });
	const [subscriptionList, setSubscriptionList] = useState([]);
	const [sortingOrderObj, setSortingOrderObj] = useState({ ...defaultSortingOrderObj })
	const [selectedArr, setSelectedArr] = useState([]);
	const [showSubscriptionModal, setShowSubscriptioModal] = useState(false);
	const [updateSubscriptionData, setUpdateSubscriptionData] = useState({ ...defaultUpdateSubscripionObj });
	const [disableSubmitBtn, setDisableSubmitBtn] = useState(false);
	const [disableGoBtn, setDisableGoBtn] = useState(false);
	const [startDateError, setStartDateError] = useState(false);
	const [endDateError, setEndDateError] = useState(false);

	let toast = useContext(ThemeContext);

	const getLicences = () => {
		getAllLicenses().then((res) => {
			if (res.isSuccess) {
				setLicencesList(res.data);
			}
		})
	}

	const getPackages = () => {
		getAllPackages().then((res) => {
			if (res.isSuccess) {
				setPackagesList(res.data);
			}
		})
	}

	const updateSubscriptionDetail = (val, fld) => {
		let dta = subscriptionObj;
		dta[fld] = val;
		setSubscriptionObj({ ...dta });
	}

	const onChangeSubscriptionDetail = (val, fld) => {
		let dta = updateSubscriptionData;
		dta[fld] = val;
		setUpdateSubscriptionData({ ...dta });
	}

	const getSubscripitonListByFilter = () => {
		let body = { ...subscriptionObj };
		setDisableGoBtn(true);
		SubscriptionServices.getDetailByFilter(body).then((res) => {
			setDisableGoBtn(false);
			if (res.isSuccess) {
				setDisableGoBtn(false);
				setSubscriptionList(res.data);
			} else {
				setDisableGoBtn(false);
			}
		}).catch(e => {
			setDisableGoBtn(false);
		})
	}

	const editSubscriptionValue = (item) => {
		SubscriptionServices.getSubscriptionById(item?.subscriptionId).then((res) => {
			if (res.isSuccess) {
				setShowSubscriptioModal(true);
				setUpdateSubscriptionData(res?.data);
			}
		})
	}

	const onCloseSubscriptionModal = () => {
		setShowSubscriptioModal(false);
		setStartDateError(false);
		setEndDateError(false);
		setUpdateSubscriptionData({ ...defaultUpdateSubscripionObj });
	}

	const onUpdateSubscriptionModal = () => {
		let isValid = true;

		if (!updateSubscriptionData?.startDate || updateSubscriptionData?.startDate === "") {
			setStartDateError(true);
			isValid = false;
		}

		if (!updateSubscriptionData?.endDate || updateSubscriptionData?.endDate === "") {
			setEndDateError(true);
			isValid = false;
		}
		let body = {
			"subscriptionId": updateSubscriptionData?.subscriptionId,
			"licenseId": updateSubscriptionData?.licenseId,
			"packageId": updateSubscriptionData?.packageId,
			"userName": updateSubscriptionData?.userName,
			"subscriptionStatus": updateSubscriptionData?.subscriptionStatus,
			"startDate": updateSubscriptionData?.startDate,
			"endDate": updateSubscriptionData?.endDate,
			"adminComment": updateSubscriptionData?.adminComment
		}
		if (isValid) {
			setDisableSubmitBtn(true);
			SubscriptionServices.updateSubscription(body).then((res) => {
				setDisableSubmitBtn(false);
				if (res.isSuccess) {
					let tempArray = [...subscriptionList];
					let index = tempArray.findIndex((item) => item?.subscriptionId === updateSubscriptionData?.subscriptionId);
					tempArray[index] = res.data;
					setSubscriptionList([...tempArray]);
					setUpdateSubscriptionData({ ...defaultUpdateSubscripionObj });
					toast.success(res?.successMessage);
					setShowSubscriptioModal(false);
					setDisableSubmitBtn(false);
				} else {
					toast.error(res?.exception?.message);
					setDisableSubmitBtn(false);
				}
			}).catch(e => {
				setDisableSubmitBtn(false);
			})
		}
	}

	const onSelectionRow = (item) => {
		if (!!subscriptionList && subscriptionList.length > 0) {
			const selectedRow = subscriptionList.map((elem) => { return elem.subscriptionId }).indexOf(item.subscriptionId);
			if (selectedRow > -1) {
				setSelectedArr([subscriptionList[selectedRow]]);
			}
		}
	}

	const checkItem = (item) => {
		const checkData = !!selectedArr && selectedArr.some((val) => val?.subscriptionId === item?.subscriptionId);
		return checkData;
	}

	const creatingSortingArrFn = (field, type) => {
		let order = sortingOrderObj.sortingOrder;
		if (field === sortingOrderObj.upDownArrowColumn) {
			order = order === 'asc' ? 'desc' : 'asc';
			setSelectedArr([]);
		} else {
			order = 'asc';
			setSelectedArr([]);
		}
		setSortingOrderObj({ sortingOrder: order, upDownArrowColumn: field, fieldType: type })
	}

	useEffect(() => {
		if (!!sortingOrderObj && sortingOrderObj.upDownArrowColumn !== '') {
			let sortedArrayByColumn = [...subscriptionList]
			sortedArrayByColumn = hanldeSortingArray(sortedArrayByColumn, sortingOrderObj.upDownArrowColumn, sortingOrderObj.fieldType, sortingOrderObj.sortingOrder)
			setSubscriptionList(sortedArrayByColumn);
		}
	}, [sortingOrderObj])

	useEffect(() => {
		getLicences();
		getPackages();
	}, [])

	return (
		<div id='tabs'>
			<div className="maintitle-box">
				<div className="w-50 d-inline-block">
					<h2 className="maintitle "><img className="main-title-img" src={"/images/svg/subscription.svg"} alt="" />Subscriptions</h2>
				</div>
				<div className="w-50 d-inline-block">
					<div className="float-end ">
						<div className="d-inline-block mr-3"><i id="subscriptionRefresh" className="fa fa-refresh font-size-14 remove_arrow_summary"
							onClick={() => { getLicences(); getPackages(); }}></i>
						</div>
					</div>
				</div>
			</div>
			<div className='mt-2 mb-3'>
				<div className='container-fluid'>
					<div className='row'>
						<div className='col-12 col-sm-4 col-md-4 col-lg-3'>
							<label className='font11 mb-0 text-right v-align-baseline'>Licence</label>
							<select className="form-select inputborder w-100 font11"
								value={subscriptionObj?.licenseId}
								onChange={(e) => updateSubscriptionDetail(e.target.value, "licenseId")}>
								<option value="">Select</option>
								{(!!licencesList && licencesList.length > 0) && licencesList?.sort()?.map((item, index) => {
									return (
										<option key={`operatorId_${index}`} value={item?.licenseId}>{item?.operatorId} - {item?.companyName}</option>
									)
								})}
							</select>
						</div>
						<div className='col-12 col-sm-4 col-md-4 col-lg-3'>
							<label className='font11 mb-0 text-right v-align-baseline'>Package</label>
							<select className="form-select inputborder w-100 font11"
								value={subscriptionObj?.packageId}
								onChange={(e) => updateSubscriptionDetail(e.target.value, "packageId")}>
								<option value="">Select</option>
								{(!!packagesList && packagesList?.length > 0) && packagesList?.sort()?.map((item, index) => {
									return (
										<option key={`packages_${index}`} value={item?.packageId}>{item?.packageName}</option>
									)
								})}
							</select>
						</div>
						<div className='col-12 col-sm-4 col-md-4 col-lg-3'>
							<label className='font11 mb-0 text-right v-align-baseline'>User Name</label>
							<input
								type="text"
								className="font11 inputborder mb-1 ml-1 w-100 width-120"
								maxLength="50"
								value={subscriptionObj?.userName}
								onChange={(e) => updateSubscriptionDetail(e.target.value, "userName")}
							/>
						</div>
						<div className='col-12 col-sm-4 col-md-4 col-lg-3'>
							<label className='font11 mb-0 text-right v-align-baseline'>Subscription</label>
							<select
								className="form-select inputborder w-100 font11"
								value={subscriptionObj?.subscriptionStatus}
								onChange={(e) => updateSubscriptionDetail(e.target.value, "subscriptionStatus")}>
								<option value="All">All</option>
								<option value="Pending">Pending</option>
								<option value="Approved">Approved</option>
								<option value="Rejected">Rejected</option>
							</select>
						</div>
						<div className='col-12 col-sm-4 col-md-4 col-lg-3'>
							<label className="font11 mb-0 text-right v-align-baseline">Start Date:</label>
							<DateTime
								value={!!subscriptionObj?.startDate ? moment(subscriptionObj?.startDate).format("DD-MM-YYYY") : 'dd/mm/yyyy'}
								onChange={(time) => updateSubscriptionDetail(time, "startDate")}
								closeOnSelect={true}
								dateFormat='DD-MM-YYYY'
								timeFormat={false}
							/>
						</div>
						<div className='col-12 col-sm-4 col-md-4 col-lg-3'>
							<label className="font11 mb-0 text-right v-align-baseline">End Date:</label>
							<DateTime
								value={!!subscriptionObj?.endDate ? moment(subscriptionObj?.endDate).format("DD-MM-YYYY") : 'dd/mm/yyyy'}
								onChange={(time) => updateSubscriptionDetail(time, "endDate")}
								closeOnSelect={true}
								dateFormat='DD-MM-YYYY'
								timeFormat={false}
							/>
						</div>
						<div className='col-12 col-sm-4 col-md-4 col-lg-3'>
							<button className="btnmain btn btn-primary ml-2 mt-20" onClick={() => getSubscripitonListByFilter()}>{disableGoBtn && <i className="fa fa-spinner fa-spin mr-2"></i>} Go</button>
						</div>
					</div>
				</div>
			</div>
			<div className="thead-fixed">
				<table className="table table-bordered table-strip w-100 mb-30 new-data-asc-desc">
					<thead>
						<tr className="thead-dard-bg">
							<th className=" srn-width">Sr</th>
							<th className={`feed-m-name sorting sorting_${sortingOrderObj.upDownArrowColumn === 'companyName' && sortingOrderObj.sortingOrder === 'asc' ? 'asc' : 'desc'}`} onClick={() => creatingSortingArrFn('companyName', 'Text')}>Company Name</th>
							<th className={`lic-domain sorting sorting_${sortingOrderObj.upDownArrowColumn === 'packageName' && sortingOrderObj.sortingOrder === 'asc' ? 'asc' : 'desc'}`} onClick={() => creatingSortingArrFn('packageName', 'Text')}>Package Name</th>
							<th className={`lic-status sorting sorting_${sortingOrderObj.upDownArrowColumn === 'userName' && sortingOrderObj.sortingOrder === 'asc' ? 'asc' : 'desc'}`} onClick={() => creatingSortingArrFn('userName', 'Text')}>User Name </th>
							<th className={`lic-status sorting sorting_${sortingOrderObj.upDownArrowColumn === 'mobile' && sortingOrderObj.sortingOrder === 'asc' ? 'asc' : 'desc'}`} onClick={() => creatingSortingArrFn('mobile', 'Text')}>Mobile No </th>
							<th className={`lic-status sorting sorting_${sortingOrderObj.upDownArrowColumn === 'email' && sortingOrderObj.sortingOrder === 'asc' ? 'asc' : 'desc'}`} onClick={() => creatingSortingArrFn('email', 'Text')}>Email</th>
							<th className={`lic-status sorting sorting_${sortingOrderObj.upDownArrowColumn === 'subscriptionStatus' && sortingOrderObj.sortingOrder === 'asc' ? 'asc' : 'desc'}`} onClick={() => creatingSortingArrFn('subscriptionStatus', 'Text')}>Status </th>
							<th className={`lic-status sorting sorting_${sortingOrderObj.upDownArrowColumn === 'startDate' && sortingOrderObj.sortingOrder === 'asc' ? 'asc' : 'desc'}`} onClick={() => creatingSortingArrFn('startDate', 'Text')}>Start Date </th>
							<th className={`lic-status sorting sorting_${sortingOrderObj.upDownArrowColumn === 'endDate' && sortingOrderObj.sortingOrder === 'asc' ? 'asc' : 'desc'}`} onClick={() => creatingSortingArrFn('endDate', 'Text')}>End Date </th>
							<th className={`lic-status sorting sorting_${sortingOrderObj.upDownArrowColumn === 'adminComment' && sortingOrderObj.sortingOrder === 'asc' ? 'asc' : 'desc'}`} onClick={() => creatingSortingArrFn('adminComment', 'Text')}>Admin Comment</th>
							<th className={`lic-status sorting sorting_${sortingOrderObj.upDownArrowColumn === 'userComment' && sortingOrderObj.sortingOrder === 'asc' ? 'asc' : 'desc'}`} onClick={() => creatingSortingArrFn('userComment', 'Text')}>User Comment</th>
							<th className={`lic-status sorting sorting_${sortingOrderObj.upDownArrowColumn === 'createdOn' && sortingOrderObj.sortingOrder === 'asc' ? 'asc' : 'desc'}`} onClick={() => creatingSortingArrFn('createdOn', 'Text')}>Created On </th>
						</tr>
					</thead>
					<tbody>
						{(!!subscriptionList && subscriptionList.length > 0) ? subscriptionList.map((item, i) => {
							const convertedStartDate = !!item?.startDate ? moment(new Date(item.startDate + "+00:00").toLocaleString('sv-SE')).format('DD-MM-YYYY') : "";
							const convertedEndDate = !!item?.endDate ? moment(new Date(item.endDate + "+00:00").toLocaleString('sv-SE')).format('DD-MM-YYYY') : "";
							const convertedDate = !!item?.createdOn ? moment(new Date(item.createdOn + "+00:00").toLocaleString('sv-SE')).format('DD-MM-YYYY') : "";
							return (
								<tr key={"subscriptionList" + i} onDoubleClick={() => { editSubscriptionValue(item) }} onClick={() => onSelectionRow(item)}
									className={`${checkItem(item) ? 'selected-tr' : ''} `}>
									<td className="">{i + 1}</td>
									<td className="">{item.companyName}</td>
									<td className="">{item.packageName}</td>
									<td className="">{item.userName}</td>
									<td className="">{item.mobile}</td>
									<td className="">{item.email}</td>
									<td className="">{item.subscriptionStatus}</td>
									<td className="">{convertedStartDate}</td>
									<td className="">{convertedEndDate}</td>
									<td className="">{item.adminComment}</td>
									<td className="">{item.userComment}</td>
									<td className="">{convertedDate}</td>
								</tr>
							)
						}) : <NoDataError colspn={12} />}
					</tbody>
				</table>
			</div>
			<div className="login-popup">
				<Modal
					className="login subscribe"
					show={showSubscriptionModal}
					onHide={() => onCloseSubscriptionModal()}
					backdrop="static"
					dialogAs={subscriptionModalDragModal}
					animation={false}
					size="md"
					centered
				>
					<Modal.Header closeButton style={{ border: "none" }}>
						<Modal.Title className="w-100">
							Edit Subscription
						</Modal.Title>
					</Modal.Header>
					<Modal.Body style={{ display: "flex", flexDirection: "column" }}>
						<div className="p-1">
							<div className="feederbox">
								<div className="container p-0">
									<div className="fidderbox-inner office-height-modulemaster subscription-popup ">
										<div className="row">
											<div className="col-6">
												<div className="mb-1 row prl-7">
													<label htmlFor="inputDigit" className="col-sm-3 font11 text-right p-0 line-h20 mb-0">Company Name:</label>
													<div className={`col-sm-9 pl-2 pr-0 `}>
														<input
															type="text"
															className="inputborder font11 w-100 ml-2 h20 mb-2"
															value={updateSubscriptionData?.companyName}
															onChange={(e) => onChangeSubscriptionDetail(e.target.value, "companyName")}
															disabled
														/>
													</div>
												</div>
											</div>
											<div className='col-6'>
												<div className="mb-1 row prl-7">
													<label htmlFor="inputSymbol" className="col-sm-3 font11 text-right p-0 line-h20 mb-0">Package Name:</label>
													<div className={`col-sm-9 p-0 pl-2`}>
														<input
															type="text"
															className="inputborder font11 w-100 ml-2 h20 mb-2"
															value={updateSubscriptionData?.packageName}
															onChange={(e) => onChangeSubscriptionDetail(e.target.value, "packageName")}
															disabled
														/>
													</div>
												</div>
											</div>
											<div className='col-6'>
												<div className="mb-1 row prl-7">
													<label className="col-sm-3 font11 text-right p-0 line-h20 mb-0">UserName:</label>
													<div className={`col-sm-9 p-0 pl-2`}>
														<input
															type="text"
															className="inputborder font11 w-100 ml-2 h20 mb-2"
															value={updateSubscriptionData?.userName}
															onChange={(e) => onChangeSubscriptionDetail(e.target.value, "userName")}
															disabled
														/>
													</div>
												</div>
											</div>
											<div className='col-6'>
												<div className="mb-1 row prl-7">
													<label className="col-sm-3 font11 text-right p-0 line-h20 mb-0">Status:</label>
													<div className={`col-sm-9 p-0 pl-2`}>
														<select
															className="form-select inputborder w-100 font11 ml-2 h20 mb-2"
															value={updateSubscriptionData?.subscriptionStatus}
															onChange={(e) => onChangeSubscriptionDetail(e.target.value, "subscriptionStatus")}
														>
															<option value="Pending">Pending</option>
															<option value="Approved">Approved</option>
															<option value="Rejected">Rejected</option>
														</select>
													</div>
												</div>
											</div>
											<div className='col-6'>
												<div className="mb-1 row prl-7">
													<label className="col-sm-3 font11 text-right p-0 line-h20 mb-0">Start Date:</label>
													<div className={`col-sm-9 p-0 pl-2 ${startDateError ? "error" : ''}`}>
														<DateTime
															value={!!updateSubscriptionData?.startDate ? moment(updateSubscriptionData?.startDate).format("DD-MM-YYYY") : 'dd/mm/yyyy'}
															onChange={(time) => onChangeSubscriptionDetail(time, "startDate")}
															closeOnSelect={true}
															dateFormat='DD-MM-YYYY'
															timeFormat={false}
														/>
													</div>
												</div>
											</div>
											<div className='col-6'>
												<div className="mb-1 row prl-7">
													<label className="col-sm-3 font11 text-right p-0 line-h20 mb-0">End Date:</label>
													<div className={`col-sm-9 p-0 pl-2 ${endDateError ? "error" : ''}`}>
														<DateTime
															value={!!updateSubscriptionData?.endDate ? moment(updateSubscriptionData?.endDate).format("DD-MM-YYYY") : 'dd/mm/yyyy'}
															onChange={(time) => onChangeSubscriptionDetail(time, "endDate")}
															closeOnSelect={true}
															dateFormat='DD-MM-YYYY'
															timeFormat={false}
														/>
													</div>
												</div>
											</div>
											<div className='col-6'>
												<div className="mb-1 row prl-7">
													<label className="col-sm-3 font11 text-right p-0 line-h20 mb-0">Comment:</label>
													<div className={`col-sm-9 p-0 pl-2`}>
														<input
															type="text"
															className="inputborder font11 w-100 ml-2 h20 mb-2"
															value={updateSubscriptionData?.adminComment}
															onChange={(e) => onChangeSubscriptionDetail(e.target.value, "adminComment")}
														/>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</Modal.Body>
					<Modal.Footer>
						<div>
							<div className="w-100 text-right p-1">
								<Button className="btnmain mr-3" onClick={() => { onUpdateSubscriptionModal(); }}>
									{disableSubmitBtn && <i className="fa fa-spinner fa-spin mr-2"></i>} Submit
								</Button>
								<Button onClick={() => onCloseSubscriptionModal()} className="btnmain-danger">
									Cancel
								</Button>
							</div>
						</div>
					</Modal.Footer>
				</Modal>
			</div>
		</div>
	)
}

export default Subscriptions